import React from 'react'
import * as styles from './Footer.module.scss'
import { Nav, Row, Col, Container, ListGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationArrow, faPhoneAlt, faEnvelope, faCircle } from '@fortawesome/free-solid-svg-icons'

// #TODO add commit hash
// const commitHash = process.env.REACT_APP_VERSION || 'dev'

export default function Footer(props) {
  return (
    <Container className={styles.footer}>
      <Container>
        <Container className={styles.footerTop}>
          <Row>
            <Col xs={12} className="d-block d-sm-block d-lg-block">
              <Row className={styles.footerMinContent}>
                <ListGroup className={styles.footer_listItem}>
                  <h2>NUS Libraries</h2>
                  <li>
                    <FontAwesomeIcon icon={faLocationArrow} className={styles.iconArrow} />
                    <pre className={styles.address}>Central Library{'\n'}
                      12 Kent Ridge Crescent{'\n'}
                      Singapore 119275</pre>
                  </li>
                  <li><FontAwesomeIcon icon={faPhoneAlt} className={styles.icon} /><span>+65 6516 2028</span></li>
                  <li><FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
                    <span><a href="mailto:askalib@nus.edu.sg" target="_self">askalib@nus.edu.sg</a><br /></span>
                  </li>
                </ListGroup>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container className={styles.footerCopyright} style={{ display: 'flex' }}>
        <Col>
          <Row className={styles.footerBottom}>
            <p>©<a href="http://www.nus.edu.sg">National University of Singapore</a>. All Rights Reserved.</p>
          </Row>
          <Row className={styles.footerBottom}>
            <Nav>
              <li><a href="http://www.nus.edu.sg/legal-information-notices" target="_blank" rel="noopener noreferrer">Legal</a></li><FontAwesomeIcon icon={faCircle} className={styles.pseudoIcon} />
              <li><a href="http://www.nus.edu.sg/identity" target="_blank" rel="noopener noreferrer">Branding guidelines</a></li><FontAwesomeIcon icon={faCircle} className={styles.pseudoIcon} />
              <li><a href="http://www.nus.edu.sg/contact" target="_blank" rel="noopener noreferrer">Contact us</a></li><FontAwesomeIcon icon={faCircle} className={styles.pseudoIcon} />
              <li><a href="http://cn.nus.edu.sg/" target="_blank" rel="noopener noreferrer">中文</a></li>
            </Nav>
          </Row>
        </Col>
      </Container>

    </Container>
  )
}